module.exports = __webpack_public_path__ + "img/trinapp-suite-globe.d240511e.png";